import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { Callout } from '@/components/Callout';
import { FileLink } from '@/components/FileLink';
import { PageHeader } from '@/components/PageHeader';
import { FACULTIES } from '@/data/faculties';

export function Courses() {
  return (
    <>
      <PageHeader
        title="Courses & syllabi"
        intro="ITES sets the syllabus and examinations for nine faculties of technical and vocational study. Each syllabus lists its courses and what is examined."
      />
      <Container className="pt-[clamp(40px,6vw,72px)] pb-[clamp(56px,7vw,96px)]">
        <ul className="m-0 grid list-none grid-cols-[repeat(auto-fill,minmax(min(100%,320px),1fr))] gap-x-7 gap-y-10 p-0">
          {FACULTIES.map((f) => (
            <li key={f.slug} className="flex flex-col">
              <AppLink href={`/courses/${f.slug}`} className="block text-navy-900 no-underline hover:text-teal-700">
                <img
                  src={f.photo.src}
                  alt=""
                  width={f.photo.width}
                  height={f.photo.height}
                  loading="lazy"
                  decoding="async"
                  className="block aspect-[4/3] w-full bg-img-fallback object-cover"
                />
                <span className="mt-4 flex items-baseline gap-3">
                  <span aria-hidden="true" className="font-mono text-[0.75rem] text-teal-700">{f.n}</span>
                  {/* A heading, so a screen-reader user can jump from faculty to faculty. */}
                  <h2 className="m-0 font-serif text-[1.4375rem] leading-[1.25] font-semibold">{f.name}</h2>
                </span>
              </AppLink>
              <p className="mt-2 mb-0 text-[1rem] leading-[1.5] text-muted">{f.desc}</p>
              <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2 text-[0.9375rem]">
                <AppLink
                  href={`/courses/${f.slug}`}
                  aria-label={`Faculty details: ${f.name}`}
                  className="tap font-semibold underline"
                >
                  Faculty details →
                </AppLink>
                <FileLink href={f.syllabusUrl} label="Syllabus PDF" ariaLabel={`Syllabus PDF: ${f.name}`} />
              </div>
            </li>
          ))}
        </ul>
        <Callout className="mt-14 flex flex-wrap items-center justify-between gap-4" aria-label="Find an institute">
          <p className="m-0 max-w-[44em] text-[1.0625rem] text-ink">
            Courses are taught at ITES-affiliated institutes. To study a course, find an institute near you.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-3 font-semibold">
            <AppLink href="/centres" className="tap underline">Find an institute →</AppLink>
            <AppLink href="/notices" className="tap underline">Current fee chart →</AppLink>
          </div>
        </Callout>
      </Container>
    </>
  );
}
